import { required, length, regexp, money } from 'js/utils/Validation/validationRules';

export const FORM_FIELD_TYPE = {
    name: 'type',
    hideFromUser: true
};

export const FORM_FIELD_AMOUNT = {
    id: 'amount',
    type: 'text',
    name: 'amount',
    placeholder: 'field.amount.placeholder',
    label: 'field.amount.label',
    inputMode: 'decimal'
};

export const FORM_FIELD_PIN = {
    id: 'pin',
    type: 'text',
    name: 'pin',
    placeholder: 'field.pinNumber.placeholder',
    label: 'field.pinNumber.label',
    inputMode: 'numeric'
};

export const FORM_SUBMIT_BUTTON = {
    id: 'transfer',
    type: 'button',
    action: 'submit',
    label: 'submit.transfer',
    name: 'transfer'
};

export const FORM_VALIDATION_CONFIG = {
    amount: [
        required({
            error: 'playtech.mobile.fund-transfer.field.amount.validation.required'
        }),
        money()
    ],
    pin: [
        required({
            error: 'playtech.mobile.fund-transfer.field.pinNumber.validation.required'
        }),
        regexp({
            re: '\\d{1,4}',
            error: 'playtech.mobile.fund-transfer.field.pinNumber.validation.regexp'
        }),
        length({
            max: 4,
            min: 4,
            error: 'playtech.mobile.fund-transfer.field.pinNumber.validation.length'
        })
    ]
};
